import type { VendorDefinition } from "../types";

/** Advertising and cross-site tracking. Everything here is `marketing`. */
export const MARKETING_VENDORS: VendorDefinition[] = [
  {
    id: "meta-pixel",
    name: "Meta Pixel (Facebook)",
    provider: "Meta Platforms Ireland Ltd.",
    category: "marketing",
    purpose: {
      de: "Ordnet Käufe und Anfragen den Facebook- und Instagram-Anzeigen zu, über die Besucher gekommen sind, und bildet Zielgruppen für weitere Werbung.",
      en: "Attributes purchases and enquiries to the Facebook and Instagram ads visitors arrived from, and builds audiences for further advertising.",
    },
    domains: ["connect.facebook.net", "facebook.com", "facebook.net"],
    cookies: [
      { name: "_fbp", retention: { de: "3 Monate", en: "3 months" } },
      { name: "_fbc", retention: { de: "3 Monate", en: "3 months" } },
    ],
    usTransfer: true,
    privacyUrl: "https://www.facebook.com/privacy/policy",
  },
  {
    id: "google-ads",
    name: "Google Ads",
    provider: "Google Ireland Ltd.",
    category: "marketing",
    purpose: {
      de: "Misst, welche Google-Anzeige zu einer Buchung geführt hat, und spielt Besuchern dieser Website erneut Anzeigen aus (Remarketing).",
      en: "Measures which Google ad led to a booking and re-shows ads to visitors of this site (remarketing).",
    },
    domains: [
      "googleadservices.com",
      "googlesyndication.com",
      "doubleclick.net",
      "google.com/ads",
      "adservice.google.com",
    ],
    cookies: [
      { name: "_gcl_*", retention: { de: "90 Tage", en: "90 days" } },
      { name: "IDE", retention: { de: "13 Monate", en: "13 months" } },
    ],
    usTransfer: true,
    privacyUrl: "https://policies.google.com/technologies/ads",
  },
  {
    id: "linkedin-insight",
    name: "LinkedIn Insight Tag",
    provider: "LinkedIn Ireland Unlimited Company",
    category: "marketing",
    purpose: {
      de: "Misst den Erfolg von LinkedIn-Anzeigen und bildet Zielgruppen aus Besuchern dieser Website.",
      en: "Measures LinkedIn ad performance and builds audiences from this site's visitors.",
    },
    domains: ["snap.licdn.com", "licdn.com", "linkedin.com"],
    cookies: [
      { name: "li_sugr", retention: { de: "3 Monate", en: "3 months" } },
      { name: "bcookie", retention: { de: "1 Jahr", en: "1 year" } },
    ],
    usTransfer: true,
    privacyUrl: "https://www.linkedin.com/legal/privacy-policy",
    strictOnly: true,
  },
  {
    id: "tiktok-pixel",
    name: "TikTok Pixel",
    provider: "TikTok Information Technologies UK Ltd.",
    category: "marketing",
    purpose: {
      de: "Misst den Erfolg von TikTok-Anzeigen und bildet Zielgruppen aus Besuchern dieser Website.",
      en: "Measures TikTok ad performance and builds audiences from this site's visitors.",
    },
    domains: ["analytics.tiktok.com", "tiktok.com"],
    cookies: [{ name: "_ttp", retention: { de: "13 Monate", en: "13 months" } }],
    usTransfer: true,
    privacyUrl: "https://www.tiktok.com/legal/privacy-policy",
    strictOnly: true,
  },
  {
    id: "intercom",
    name: "Intercom",
    provider: "Intercom R&D Unlimited Company",
    category: "functional",
    purpose: {
      de: "Stellt den Chat für Support-Anfragen bereit und ordnet laufende Unterhaltungen wieder zu.",
      en: "Provides the support chat and reconnects visitors to their ongoing conversations.",
    },
    domains: ["intercom.io", "intercomcdn.com", "intercomassets.com"],
    cookies: [{ name: "intercom-*", retention: { de: "9 Monate", en: "9 months" } }],
    usTransfer: true,
    privacyUrl: "https://www.intercom.com/legal/privacy",
    strictOnly: true,
  },
];
